const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20warm-toned%20abstract%20portrait%20avatar%20with%20coral%20and%20peach%20gradients%2C%20simple%20geometric%20face%20silhouette%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-1-2026&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我追了三天了，越吃越上头！反转再反转，比电视剧还精彩，建议还没入坑的赶紧补课。',
    likes: '2.3万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20warm-toned%20abstract%20portrait%20avatar%20with%20amber%20gradients%2C%20simple%20geometric%20face%20silhouette%2C%20clean%20modern%20flat%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-2-2026&orientation=squarish',
    name: '理性吃瓜人',
    time: '4小时前',
    content: '作为一个老吃瓜群众，我觉得还是要等官方通报出来再下结论，现在网络上的信息太杂了。',
    likes: '1.8万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20warm-toned%20abstract%20portrait%20avatar%20with%20peach%20gradients%2C%20simple%20geometric%20face%20silhouette%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-3-2026&orientation=squarish',
    name: '前排兜售瓜子',
    time: '6小时前',
    content: '笑死我了，评论区比正文还好看，每次来91吃瓜都能在评论区收获双倍快乐。',
    likes: '1.5万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20warm-toned%20abstract%20portrait%20avatar%20with%20coral%20gradients%2C%20simple%20geometric%20face%20silhouette%2C%20clean%20modern%20flat%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-4-2026&orientation=squarish',
    name: '八卦研究员',
    time: '9小时前',
    content: '我整理了完整的时间线和各方回应，建议大家先看汇总帖再吃瓜，省得被各种截图误导。',
    likes: '1.2万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20warm-toned%20abstract%20portrait%20avatar%20with%20amber%20and%20peach%20gradients%2C%20simple%20geometric%20face%20silhouette%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-5-2026&orientation=squarish',
    name: '深夜吃瓜选手',
    time: '11小时前',
    content: '我就想问问，有没有人和我一样，每天睡前必须刷一遍91吃瓜才能安心睡觉的？',
    likes: '1.1万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          吃瓜热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          来自吃瓜群众的真实声音，每一条都代表群众的智慧
        </p>
        <div className="max-w-3xl mx-auto space-y-4">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                    {item.content}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-thumb-up-line"></i>
                      </span>
                      {item.likes}
                    </span>
                    <span className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-chat-1-line"></i>
                      </span>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}